{
  "name": "asu-apgap-frontend",
  "version": "1.0.0",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "test": "ng test --watch=false --browsers ChromeHeadless",
    "build": "ng build",
    "watch": "ng build --watch --configuration development",
    "lint": "npx eslint \"src/**/*.{js,jsx,ts,tsx,html}\" --quiet --fix",
    "format": "npx prettier \"src/**/*.{js,jsx,ts,tsx,html,css,scss}\" --write",
    "prepare": "husky install"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^21.2.24",
    "@angular/common": "^21.2.24",
    "@angular/compiler": "^21.2.24",
    "@angular/core": "^21.2.24",
    "@angular/forms": "^21.2.24",
    "@angular/platform-browser": "^21.2.24",
    "@angular/platform-browser-dynamic": "^21.2.24",
    "@angular/router": "^21.2.24",
    "@fortawesome/angular-fontawesome": "^4.0.0",
    "@fortawesome/free-brands-svg-icons": "^7.3.1",
    "@fortawesome/free-regular-svg-icons": "^7.3.1",
    "@fortawesome/free-solid-svg-icons": "^7.3.1",
    "@ng-select/ng-select": "^21.8.2",
    "@ngrx/effects": "^21.1.1",
    "@ngrx/store": "^21.1.1",
    "@ngrx/store-devtools": "^21.1.1",
    "@perspective-dev/client": "^4.5.1",
    "@perspective-dev/viewer": "^4.5.1",
    "@perspective-dev/viewer-charts": "^4.5.1",
    "@perspective-dev/viewer-datagrid": "^4.5.1",
    "d3-scale": "^4.0.2",
    "d3-shape": "^3.2.0",
    "driver.js": "^1.3.1",
    "ngrx-store-localstorage": "^20.1.0",
    "rxjs": "~7.8.0",
    "tslib": "^2.3.0",
    "xng-breadcrumb": "^14.1.0",
    "zone.js": "~0.15.0"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^21.2.24",
    "@angular/cli": "^21.2.24",
    "@angular/compiler-cli": "^21.2.24",
    "@eslint/js": "^9.18.0",
    "@semantic-release/changelog": "^6.0.3",
    "@semantic-release/git": "^10.0.1",
    "@semantic-release/github": "^12.0.10",
    "@types/d3-scale": "^4.0.9",
    "@types/d3-shape": "^3.2.0",
    "@types/jasmine": "~5.1.0",
    "autoprefixer": "^10.6.1",
    "daisyui": "^4.12.23",
    "eslint": "^8.57.1",
    "eslint-config-prettier": "^8.8.0",
    "eslint-plugin-prettier": "^4.2.1",
    "globals": "^15.14.0",
    "husky": "^8.0.0",
    "jasmine-core": "~5.4.0",
    "karma": "~6.4.0",
    "karma-chrome-launcher": "~3.2.0",
    "karma-coverage": "~2.2.0",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "~2.1.0",
    "postcss": "^8.5.28",
    "prettier": "^3.9.9",
    "semantic-release": "^25.0.9",
    "tailwindcss": "^3.4.17",
    "typescript": "~5.9.3",
    "typescript-eslint": "^8.70.1"
  },
  "engines": {
    "node": "^20.19.0 || ^22.12.0 || >=24.0.0"
  }
}
